import { render, staticRenderFns } from "./personal-photo.vue?vue&type=template&id=07f55030&"
import script from "./personal-photo.vue?vue&type=script&lang=js&"
export * from "./personal-photo.vue?vue&type=script&lang=js&"
import style0 from "./personal-photo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./personal-photo.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(component)

export default component.exports